import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { PatientApi } from "@/Modules/Patients/Models/Api";
import type { Patient } from "@/Modules/Patients/Models/Domain";

import { camel } from "@/Utils/Camelize";
import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

const PatientTransformer: TransformerExtended<Patient, PatientApi> & {
  toRecord: (input: PatientApi[]) => Record<string, Patient>;
} = {
  ...DefaultTransformerGenerator<Patient, PatientApi>(),

  toDomain(input: PatientApi) {
    return camel<PatientApi, Patient>(input);
  },

  toRecord(input: PatientApi[]): Record<string, Patient> {
    return input.reduce<Record<string, Patient>>((acc, item) => {
      const domainPatient = camel<PatientApi, Patient>(item);
      acc[domainPatient.uuid] = domainPatient;

      return acc;
    }, {});
  },
};

export type AnswerTransformerType = TransformerExtended<Patient, PatientApi>;

export default PatientTransformer;
